module.exports = __webpack_public_path__ + "img/database.e4d7fe08.svg";